export default "__VITE_ASSET__BVK26i06__"